import type { Tuple } from '@clearverify/types';

import { VerificationRequestType } from 'src/api';
import type { SelectFieldOption } from 'src/types/components';

export const VERIFICATION_TYPES_OPTIONS = [
  {
    label: 'Verification Of Employment',
    value: VerificationRequestType.VerificationOfEmployment,
  },
  {
    label: 'Verification Of Income',
    value: VerificationRequestType.VerificationOfIncome,
  },
] as const satisfies Tuple<SelectFieldOption, 2>;
